export default __webpack_public_path__ + "static/media/logo-lasko.1df86e55.png";